<template>
	<div id="app">
		<section class="container">
			<div class="divider"></div>
			<!--questionBox-->
			<div class="questionBox" id="app">
				<!-- transition -->
				<transition
					:duration="{ enter: 100, leave: 100 }"
					enter-active-class="animated fadeIn"
					leave-active-class="animated zoomOut"
					mode="out-in"
				>
					<!--qusetionContainer-->
					<div
						class="questionContainer"
						v-if="questionIndex<quiz.questions.length"
						v-bind:key="questionIndex"
					>
						<!-- questionTitle -->
						<h2 class="titleContainer title animated zoomIn">{{ quiz.questions[questionIndex].text }}</h2>

						<!-- quizOptions -->
						<div class="optionContainer">
							<div class="row">
								<div
									class="col-md-6 option-box"
									v-for="(response, index) in quiz.questions[questionIndex].responses"
									:key="index"
								>
									<div
										class="option"
										v-bind:class="'animated zoomIn delay-'+(index+1)+'ms'"
										@click="selectOption(response)"
									>
										<div class="text">{{ response.text }}</div>
										<div class="dress">
											<bg :fill="fillColors[index]"></bg>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--/questionContainer-->

					<!--quizCompletedResult-->
					<div
						v-if="questionIndex >= quiz.questions.length"
						v-bind:key="questionIndex"
						class="quizCompleted has-text-centered questionContainer"
					>
						<p class="book">
							<strong>Neked {{score()}} című könyvét ajánljuk.</strong>
							<br />A könyvet megvásárolhatod a Margón is!
						</p>

						<p class="book">
							<strong>Egy jó történet bárhová elvisz.</strong>
						</p>	

						<p class="book">
							{{score()}} című kötetével egészen {{destination()}}ig el tudnál menni. Természetesen egy Volvo XC40-nel.
						</p>					

						<div class="optionContainer">
							<div class="row">
								<div v-if="!showForm" class="col-md-12 option-box">
									<div class="option" v-on:click="showForm = true">
										<div class="text quizCompleted-text">
											Szeretnéd kipróbálni?
											<br />											
											KATTINTS IDE, regisztrálj és részt veszel egy sorsoláson, ahol akár te is megnyerheted egy hétvégére a Volvo XC40-et.
										</div>
										<div class="dress">
											<bg :fill="fillColors[1]"></bg>
										</div>
									</div>
								</div>
								<div v-else class="col-md-12">
									<form v-if="!sent" class="send animated zoomIn" @submit="sendForm" method="post">
										<div class="form-group is-invalid">
											<input
												v-model="email"
												type="email"
												class="form-control email-input"
												placeholder="E-mail címed"
												required
											/>
										</div>
										<div class="form-group is-invalid">
											<input
												v-model="phone"
												type="phone"
												class="form-control phone-input"
												placeholder="Telefonszámod"
												required
											/>
										</div>										
										<div class="form-check">
											<label class="form-check-label">
												<input type="checkbox" class="form-check-input" v-model="eula" required />
												Elfogadom a
												<a
													:href="quiz.eula"
													target="_blank"
													rel="noopener"
												>Margó Irodalmi Fesztivál és Könyvvásár</a> és a 
												<a
													:href="quiz.eulaVolvo"
													target="_blank"
													rel="noopener"
												>Volvo Car Corporation</a> adatkezelési tájékoztatóját.
											</label>
										</div>
										<div class="form-check">
											<label class="form-check-label">
												<input type="checkbox" class="form-check-input" v-model="gamerules" required />
												Elfogadom a
												<a
													:href="quiz.gameRules"
													target="_blank"
													rel="noopener"
												>játékszabályzatot</a>.
											</label>
										</div>										
										<input
											type="submit"
											class="btn btn-primary btn-block btn-send"
											value="Küldés"
											role="button"
										/>
									</form>
									<div v-else class="success-checkmark">
										<div class="check-icon">
											<span class="icon-line line-tip"></span>
											<span class="icon-line line-long"></span>
											<div class="icon-circle"></div>
											<div class="icon-fix"></div>
										</div>
										<p class="success-text">{{quiz.textSuccess}}</p>
									</div>
								</div>
							</div>
						</div>
						<!--/resultTitleBlock-->
					</div>
					<!--/quizCompetedResult-->
				</transition>
			</div>
			<!--/questionBox-->
			<div class="divider"></div>
		</section>
	</div>
</template>
<script>
import Bg from "./components/Bg";

export default {
	name: "app",
	components: {
		Bg
	},
	data: function() {
		return {
			quiz: window.quiz,
			showForm: false,
			questionIndex: 0,
			sent: false,
			isActive: false,
			emailError: false,
			email: "",
			eula: false,
			gamerules: false,
			fillColors: [
				"#442783",
				"#E84B54",
				"#442783",
				"#EBE201",
				"#4A51A1",
				"#EBE201"
			]
		};
	},
	methods: {
		restart: function() {
			this.questionIndex = 0;
		},
		selectOption: function(response) {
			response.books.forEach(element => {
				this.quiz.books.forEach(book => {
					if (book.id == element) {
						if (typeof book.counter == "undefined") {
							book.counter = 1;
						} else {
							book.counter = book.counter + 1;
						}
					}
				});
			});
			this.next();
		},
		next: function() {
			if (this.questionIndex < this.quiz.questions.length) this.questionIndex++;
		},
		score: function() {
			let max = null;

			this.quiz.books.forEach(book => {
				if (max == null && typeof book.counter !== "undefined") {
					max = book;
				} else if (
					typeof book.counter !== "undefined" &&
					max.counter < book.counter
				) {
					max = book;
				}
			});

			return max.title;
		},
		destination: function() {
			let max = null;

			this.quiz.books.forEach(book => {
				if (max == null && typeof book.counter !== "undefined") {
					max = book;
				} else if (
					typeof book.counter !== "undefined" &&
					max.counter < book.counter
				) {
					max = book;
				}
			});

			return max.city;
		},		
		sendForm(e) {
			e.preventDefault();

			let data = {
				book: this.score(),
				email: this.email,
				phone: this.phone,
				eula: this.eula
			};

			fetch(this.quiz.submitAction, {
				method: "POST",
				headers: {
					"Content-Type": "application/json"
				},
				redirect: "follow", // manual, *follow, error
				referrer: "no-referrer", // no-referrer, *client
				body: JSON.stringify(data) // body data type must match "Content-Type" header
			}).then(
				function() {
					this.sent = true;
				}.bind(this)
			);
		}
	}
};
</script>

<style scoped>
.title {
	font-size: 28px;
	line-height: 38px;
	text-align: center;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	font-weight: bold;
	margin-bottom: 3rem;
}

.animated {
	transition-duration: 0.05s;
}

.questionBox {
	min-height: 750px;
	margin-bottom: 3rem;
	position: relative;
	display: flex;
	border-radius: 0.5rem;
	overflow: hidden;
	padding: 1rem;
}
.delay-1ms {
	animation-delay: 0.5s;
}
.delay-2ms {
	animation-delay: 1s;
}
.delay-3ms {
	animation-delay: 1.5s;
}
.delay-4ms {
	animation-delay: 2s;
}
.delay-5ms {
	animation-delay: 2.5s;
}
.delay-6ms {
	animation-delay: 3s;
}

.questionBox header {
	padding: 1.5rem;
	text-align: center;
}

.questionBox header h1 {
	font-weight: bold;
	margin-bottom: 1rem !important;
}

.questionBox .titleContainer {
	text-align: center;
	padding: 1.5rem;
}

.questionBox .quizForm {
	display: block;
	white-space: normal;
	height: 100%;
	width: 100%;
}

.questionBox .quizForm .quizFormContainer {
	height: 100%;
	margin: 15px 18px;
}

.questionBox .quizForm .quizFormContainer .field-label {
	text-align: left;
	margin-bottom: 0.5rem;
}

.questionBox .quizCompleted {
	width: 100%;
	padding: 3rem;
	text-align: center;
}

.questionBox .quizCompleted .questionContainer{
	padding: 1rem!important;
}

.questionBox .questionContainer {
	white-space: normal;
	height: 100%;
	width: 100%;
}

.questionBox .questionContainer .optionContainer {
	margin-top: 12px;
	flex-grow: 1;
}

.questionBox .questionContainer .optionContainer .option {
	position: relative;
	font-size: 19px;
	line-height: 31px;
	text-align: center;
	letter-spacing: 0.01em;
	font-weight: bold;
	padding: 40px 10px;
	margin-bottom: 32px;
	transition: 0.3s;
	cursor: pointer;
	color: white;
	box-shadow: 5px 10px black;
	border: 1px solid transparent;
}

.questionBox .questionContainer .optionContainer .option .text {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	z-index: 25;
}

.dress {
	overflow: hidden;
	overflow: hidden;
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}

.questionBox .questionContainer .optionContainer .option svg {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
}

.option-box:nth-child(1) .option {
	background-color: #4a51a1;
}

.option-box:nth-child(2) .option {
	background-color: #442783;
}
.option-box:nth-child(3) .option {
	background-color: #e84b54;
}

.option-box:nth-child(4) .option {
	background-color: #e72482;
}

.option-box:nth-child(5) .option {
	background-color: #e8528e;
}

.option-box:nth-child(6) .option {
	background-color: #4a51a1;
}

.questionBox .questionContainer .optionContainer .option:hover {
	border: 1px solid black !important;
	background-color: white;

	color: black;
}

.questionBox .questionContainer .optionContainer .option:active {
	-webkit-transform: scale(0.9);
	box-shadow: 2px 5px black;
	transform: scale(0.9);
}

.questionBox .questionContainer .questionFooter {
	border-top: 1px solid rgba(0, 0, 0, 0.1);
	width: 100%;
	align-self: flex-end;
}

.questionBox .questionContainer .questionFooter .pagination {
	margin: 15px 25px;
}

.pagination {
	display: flex;
	justify-content: space-between;
}

.divider {
	width: 100%;
	height: 4rem;
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	background-image: url("./assets/divider.png");
	background-size: cover;
}

.book {
	font-size: 23px;
	line-height: 38px;
	text-align: center;
	letter-spacing: 0.02em;
}

.quizCompleted .option {
	margin-top: 5rem;
	margin-bottom: 0 !important;
	padding: 12rem !important;
	background-color: #442783 !important;
	color: white !important;
}

.email-input, .phone-input {
	font-size: 24px;
	height: 73px;
	border-radius: 0px;
	background-color: white;
	color: black;
	text-align: center;
	font-weight: bold;
	box-shadow: 5px 10px black;
	/* border-color: transparent; */
}
.send {
	margin-top: 3rem;
}

.btn-send {
	padding: 1.5rem;
	font-size: 24px;
	box-shadow: 5px 10px black;
	border-color: transparent;
	border-radius: 0px;
	font-weight: bold;
	background-color: #442783;
	margin-top: 2rem;
}

.form-check {
	text-align: center;
}

.form-check-label {
	text-align: center;
	margin-top: 1.5rem;
}
.form-check-label a {
	text-decoration: underline;
}

.success-checkmark {
	width: 80px;
	height: 115px;
	margin: 0 auto;
}
.success-checkmark .check-icon {
	margin-top: 3rem;
	width: 80px;
	height: 80px;
	position: relative;
	border-radius: 50%;
	box-sizing: content-box;
	border: 4px solid #e8518e;
}
.success-text {
	margin-top: 1.5rem;
	font-size: 20px;
	text-align: center;
}
.success-checkmark .check-icon::before {
	top: 3px;
	left: -2px;
	width: 30px;
	transform-origin: 100% 50%;
	border-radius: 100px 0 0 100px;
}
.success-checkmark .check-icon::after {
	top: 0;
	left: 30px;
	width: 60px;
	transform-origin: 0 50%;
	border-radius: 0 100px 100px 0;
	animation: rotate-circle 4.25s ease-in;
}
.success-checkmark .check-icon::before,
.success-checkmark .check-icon::after {
	content: "";
	height: 100px;
	position: absolute;
	background: #ffffff;
	transform: rotate(-45deg);
}
.success-checkmark .check-icon .icon-line {
	height: 5px;
	background-color: #e8518e;
	display: block;
	border-radius: 2px;
	position: absolute;
	z-index: 10;
}
.success-checkmark .check-icon .icon-line.line-tip {
	top: 46px;
	left: 14px;
	width: 25px;
	transform: rotate(45deg);
	animation: icon-line-tip 0.75s;
}
.success-checkmark .check-icon .icon-line.line-long {
	top: 38px;
	right: 8px;
	width: 47px;
	transform: rotate(-45deg);
	animation: icon-line-long 0.75s;
}
.success-checkmark .check-icon .icon-circle {
	top: -4px;
	left: -4px;
	z-index: 10;
	width: 80px;
	height: 80px;
	border-radius: 50%;
	position: absolute;
	box-sizing: content-box;
	border: 4px solid rgba(232, 81, 142, 0.65);
}
.success-checkmark .check-icon .icon-fix {
	top: 8px;
	width: 5px;
	left: 26px;
	z-index: 1;
	height: 85px;
	position: absolute;
	transform: rotate(-45deg);
	background-color: #ffffff;
}

@keyframes rotate-circle {
	0% {
		transform: rotate(-45deg);
	}
	5% {
		transform: rotate(-45deg);
	}
	12% {
		transform: rotate(-405deg);
	}
	100% {
		transform: rotate(-405deg);
	}
}
@keyframes icon-line-tip {
	0% {
		width: 0;
		left: 1px;
		top: 19px;
	}
	54% {
		width: 0;
		left: 1px;
		top: 19px;
	}
	70% {
		width: 50px;
		left: -8px;
		top: 37px;
	}
	84% {
		width: 17px;
		left: 21px;
		top: 48px;
	}
	100% {
		width: 25px;
		left: 14px;
		top: 45px;
	}
}
@keyframes icon-line-long {
	0% {
		width: 0;
		right: 46px;
		top: 54px;
	}
	65% {
		width: 0;
		right: 46px;
		top: 54px;
	}
	84% {
		width: 55px;
		right: 0px;
		top: 35px;
	}
	100% {
		width: 47px;
		right: 8px;
		top: 38px;
	}
}
</style>
